import { useStaticQuery, graphql } from "gatsby"

const useTeamMemberQuery = () => {
  const { allDatoCmsAgent } = useStaticQuery(graphql`
query Agents {
  allDatoCmsAgent(filter: {hideForLocale: {ne: true}}, sort: {position: ASC}) {
    nodes {
      id
      originalId
      title
      name
      jobTitle
      permalink
      biography {
        value
      }
      hideForLocale
      profileImage {
        ...InternalAssetProps
      }
      phone
      email
    }
  }
}
`)

  return allDatoCmsAgent.nodes
}

export default useTeamMemberQuery